import React from 'react';
import Icon from '../AppIcon';


const CreditStatusIndicator = ({ 
  creditsRemaining = 0,
  isMobile = false,
  onPurchaseCredits
}) => {
  const isLowCredits = creditsRemaining <= 2;
  const hasNoCredits = creditsRemaining === 0;

  if (isMobile) {
    return (
      <div className="tier-status w-full">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-3">
            <div 
              className="w-10 h-10 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: hasNoCredits ? 'rgba(239, 68, 68, 0.1)' : 'rgba(15, 118, 110, 0.1)' }}
            >
              <Icon 
                name="Zap" 
                size={20} 
                color={hasNoCredits ? 'var(--color-destructive)' : 'var(--color-primary)'} 
              />
            </div>
            <div>
              <div className="text-sm font-semibold text-foreground">
                {creditsRemaining} {creditsRemaining === 1 ? 'Credit' : 'Credits'}
              </div>
              <div className="text-xs text-muted-foreground caption">
                {hasNoCredits ? 'Purchase credits to continue' : 'Available for photo analysis'}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    null
  );
};

export default CreditStatusIndicator;